export const USAGE_SUMMARY_SEARCH_FILTER_KEY = 'term';
